import React from 'react';
import styles from './FaqQuestion.module.scss';
import { Faq, FaqAnswer } from '../../../Models';
import { FaqAnswerContent } from './FaqAnswerContent/FaqAnswerContent';

export interface FaqQuestionProps {
  faq: Faq;
}

export const FaqQuestion = ({
  faq
}: FaqQuestionProps): React.ReactElement<FaqQuestionProps> => {
  return (
    <div className={styles.faqQuestion}>
      <h2 className={styles.title}>{faq.question}</h2>

      {faq.answer.map((answer: FaqAnswer, indexAnswer: number) => (
        <FaqAnswerContent
          key={`faq-${faq.id}-answer-${indexAnswer}`}
          answer={answer}
        />
      ))}
    </div>
  );
};
